import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=c64b128a&scoped=true"
import script from "./Answers.vue?vue&type=script&lang=js"
export * from "./Answers.vue?vue&type=script&lang=js"
import style0 from "./Answers.vue?vue&type=style&index=0&id=c64b128a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64b128a",
  null
  
)

export default component.exports